var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3306_33408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50195 9.53125H6.92473",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50195 7.99414H6.92473",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2599 17.0276C16.2652 17.0276 15.4588 16.2212 15.4588 15.2265C15.4588 14.2317 16.2652 13.4253 17.2599 13.4253C18.2547 13.4253 19.0611 14.2317 19.0611 15.2265C19.0611 16.2212 18.2547 17.0276 17.2599 17.0276ZM21.3149 14.2924C21.1277 14.2924 20.9609 14.1735 20.901 13.9963C20.846 13.8332 20.7803 13.6751 20.7048 13.5226C20.6215 13.3547 20.655 13.1524 20.7876 13.0199L20.7877 13.0197C20.9585 12.8489 20.9585 12.5719 20.7877 12.4011L20.0853 11.6987C19.9145 11.5279 19.6375 11.5279 19.4667 11.6987L19.4666 11.6988C19.334 11.8314 19.1317 11.8649 18.9638 11.7817C18.8113 11.7061 18.6532 11.6404 18.4902 11.5854C18.3129 11.5255 18.194 11.3587 18.194 11.1716C18.194 10.93 17.9981 10.7342 17.7566 10.7342H16.7632C16.5217 10.7342 16.3258 10.93 16.3258 11.1716C16.3258 11.3587 16.207 11.5255 16.0297 11.5854C15.8667 11.6404 15.7085 11.7061 15.5561 11.7817C15.3881 11.8649 15.1858 11.8314 15.0532 11.6988L15.0531 11.6987C14.8823 11.5279 14.6054 11.5279 14.4345 11.6987L13.7322 12.4011C13.5613 12.5719 13.5613 12.8489 13.7322 13.0197L13.7323 13.0199C13.8648 13.1524 13.8983 13.3547 13.8151 13.5226C13.7396 13.6751 13.6738 13.8332 13.6188 13.9963C13.5589 14.1735 13.3921 14.2924 13.205 14.2924C12.9634 14.2924 12.7676 14.4882 12.7676 14.7298V15.7231C12.7676 15.9647 12.9634 16.1605 13.205 16.1605C13.3921 16.1605 13.5589 16.2794 13.6188 16.4567C13.6738 16.6197 13.7396 16.7779 13.8151 16.9303C13.8983 17.0982 13.8648 17.3005 13.7323 17.4331L13.7322 17.4332C13.5613 17.604 13.5613 17.881 13.7322 18.0518L14.4345 18.7542C14.6054 18.925 14.8823 18.925 15.0531 18.7542L15.0532 18.754C15.1858 18.6216 15.3881 18.588 15.5561 18.6713C15.7085 18.7468 15.8667 18.8125 16.0297 18.8675C16.207 18.9274 16.3258 19.0943 16.3258 19.2814C16.3258 19.5229 16.5217 19.7188 16.7632 19.7188H17.7566C17.9981 19.7188 18.194 19.5229 18.194 19.2814C18.194 19.0943 18.3129 18.9274 18.4902 18.8675C18.6532 18.8125 18.8113 18.7468 18.9638 18.6713C19.1317 18.588 19.334 18.6216 19.4666 18.754L19.4667 18.7542C19.6375 18.925 19.9145 18.925 20.0853 18.7542L20.7877 18.0518C20.9585 17.881 20.9585 17.604 20.7877 17.4332L20.7876 17.4331C20.655 17.3005 20.6215 17.0982 20.7048 16.9303C20.7803 16.7779 20.846 16.6197 20.901 16.4567C20.9609 16.2794 21.1277 16.1605 21.3149 16.1605C21.5565 16.1605 21.7523 15.9647 21.7523 15.7231V14.7298C21.7523 14.4882 21.5565 14.2924 21.3149 14.2924Z",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6032 3.46693L4.93869 3.4645L3.48425 3.46413L2.35902 3.46384C1.74766 3.46367 1.25195 3.9592 1.25195 4.57056V6.79297",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3498 10.3829L20.3491 3.38409C20.349 2.77281 19.8534 2.27732 19.2421 2.27745L14.8565 2.27819C14.4234 2.27823 14.0301 2.53088 13.8501 2.92473L12.8842 5.03758C12.7041 5.43151 12.3108 5.68417 11.8776 5.68417H2.3587C1.74745 5.68417 1.25195 6.1797 1.25195 6.79089V16.9851C1.25195 17.5964 1.74766 18.092 2.35903 18.0918L12.2387 18.0885",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3306_33408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMachine);
export default __webpack_public_path__ + "static/media/My_machine.48dc0e7866b609bf5a1a5fc36e6a9b80.svg";
export { ForwardRef as ReactComponent };